import { Component } from '@angular/core';
import { AnalyticsService } from '../../../../app/core/services/analytics/analytics.service';

@Component({
  selector: 'app-not-found-error',
  templateUrl: './not-found-error.component.html',
  styleUrls: ['./not-found-error.component.scss']
})
export class NotFoundErrorComponent {
  constructor(private analyticsService: AnalyticsService) {
    this.trackNotFoundError();
  }

  trackNotFoundError() {
    const attempedRoute = document.location.hostname.toLowerCase().replace('/', '');
    this.analyticsService.trackError(`erro:pagina-nao-encontrada-${attempedRoute}`);
  }
}
